/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imageuploadhint2Inputs */

const en_imageuploadhint2 = /** @type {(inputs: Imageuploadhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag & drop or click to upload`)
};

const de_imageuploadhint2 = /** @type {(inputs: Imageuploadhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder hierher ziehen oder auswählen`)
};

/**
* | output |
* | --- |
* | "Drag & drop or click to upload" |
*
* @param {Imageuploadhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imageuploadhint2 = /** @type {((inputs?: Imageuploadhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imageuploadhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imageuploadhint2(inputs)
	return de_imageuploadhint2(inputs)
});
export { imageuploadhint2 as "imageUploadHint" }